
import * as React from "react";
import { ToastProps, ToasterToast } from "./toast-types";
import { dispatch } from "./toast-reducer";

let count = 0;

export function genId() {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
}

export function processAction(action: ToastProps['action']): React.ReactNode {
  if (!action) return undefined;
  
  if (
    typeof action === 'object' &&
    action !== null &&
    !React.isValidElement(action) &&
    'label' in action &&
    'onClick' in action
  ) {
    const { label, onClick } = action as { label: string; onClick: () => void };
    return React.createElement('button', { onClick }, label);
  }
  
  return action as React.ReactNode;
}

export function createToast(props: ToastProps) {
  const id = props.id || genId();

  const update = (props: Partial<ToasterToast>) =>
    dispatch({
      type: "UPDATE_TOAST",
      toast: { ...props, id },
    });
    
  const dismiss = () =>
    dispatch({ type: "DISMISS_TOAST", toastId: id });

  // Process the action if needed
  const processedAction = processAction(props.action);

  // Create the toast
  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...props,
      id,
      action: processedAction,
      open: true,
      onOpenChange: (open) => {
        if (!open) {
          dismiss();
        }
        props.onOpenChange?.(open);
      },
    } as ToasterToast,
  });

  return {
    id,
    dismiss,
    update,
  };
}
